// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.groupsHeading {
  width: 100%;
  padding: 15px 24px 25px 35px;
  border-bottom: 1px solid #979ea4;
  background-color: #fff;
  box-sizing: border-box;
}

.groupsHeadingContent {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 0px 10px 0;
  border-bottom: 1px solid #77797b;
}

.groupsHeadingTitle {
  margin: 0;
  font-size: 16px;
  font-weight: 700;
}

.groupsHeadingDescription {
  margin: 20px 0 0;
  font-size: 14px;
}

.groupsHeadingAction {
  flex-shrink: 0;
}

.groupsHeadingGroupSelector {
  flex-shrink: 0;
}

.groupsHeadingGroupSelector .MuiFormControl-root {
  width: 310px;
}

.groupsHeadingGroupDetails {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  margin-top: 24px;
  padding: 8px 0px 8px 8px;
  border-left: 4px solid #007bc0;
}

.groupsHeadingGroupInfo {
  min-width: 0;
}

.groupsHeadingGroupName {
  margin: 0 0 16px;
  color: #000;
  font-size: 16px;
  font-weight: 700;
}

.groupsHeadingGroupMeta {
  display: flex;
  flex-wrap: wrap;
  gap: 28px;
  color: #4d4d4d;
  font-size: 14px;
}

.groupsHeadingContextAction {
  flex-shrink: 0;
  min-height: 48px;
  padding: 0 26px;
  border: 2px solid;
  background: transparent;
  cursor: pointer;
  font: inherit;
  font-size: 14px;
  font-weight: 700;
}

.groupsHeadingContextAction-default {
  border-color: #007bc0;
  color: #007bc0;
}

.groupsHeadingContextAction-default:hover:not(:disabled) {
  background: #d1e4ff;
}

.groupsHeadingContextAction-danger {
  border-color: #e20015;
  color: #e20015;
}

.groupsHeadingContextAction-danger:hover:not(:disabled) {
  background: #ffe5e8;
}

.groupsHeadingContextAction:disabled,
.groupsHeadingTab:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.groupsHeadingTabs {
  display: flex;
  gap: 24px;
  margin-top: 24px;
  margin-bottom: -25px;
  padding: 0;
  overflow-x: auto;
}

.groupsHeadingTab {
  border: 0;
  border-bottom: 2px solid transparent;
  padding: 10px 0;
  background: transparent;
  color: #000;
  cursor: pointer;
  font-family: "Bosch Sans", sans-serif;
  font-size: 14px;
  font-weight: 400;
  white-space: nowrap;
}

.groupsHeadingTab:hover:not(:disabled),
.groupsHeadingTabActive {
  border-bottom-color: #007bc0;
  color: #007bc0;
}

@media (max-width: 700px) {
  .groupsHeading {
    padding: 15px 20px 25px;
  }

  .groupsHeadingContent,
  .groupsHeadingGroupDetails {
    align-items: stretch;
    flex-direction: column;
  }

  .groupsHeadingGroupSelector .MuiFormControl-root {
    width: 100%;
  }

  .groupsHeadingGroupDetails {
    padding: 22px;
  }

  .groupsHeadingContextAction {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/componentes/ConfigGrupos/HeadingConfigGrupos.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,4BAA4B;EAC5B,gCAAgC;EAChC,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,wBAAwB;EACxB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,wBAAwB;EACxB,8BAA8B;AAChC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,eAAe;EACf,aAAa;EACb,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,oBAAoB;EACpB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,oCAAoC;EACpC,eAAe;EACf,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,qCAAqC;EACrC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;;IAEE,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":[".groupsHeading {\n  width: 100%;\n  padding: 15px 24px 25px 35px;\n  border-bottom: 1px solid #979ea4;\n  background-color: #fff;\n  box-sizing: border-box;\n}\n\n.groupsHeadingContent {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 0px 10px 0;\n  border-bottom: 1px solid #77797b;\n}\n\n.groupsHeadingTitle {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 700;\n}\n\n.groupsHeadingDescription {\n  margin: 20px 0 0;\n  font-size: 14px;\n}\n\n.groupsHeadingAction {\n  flex-shrink: 0;\n}\n\n.groupsHeadingGroupSelector {\n  flex-shrink: 0;\n}\n\n.groupsHeadingGroupSelector .MuiFormControl-root {\n  width: 310px;\n}\n\n.groupsHeadingGroupDetails {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 24px;\n  margin-top: 24px;\n  padding: 8px 0px 8px 8px;\n  border-left: 4px solid #007bc0;\n}\n\n.groupsHeadingGroupInfo {\n  min-width: 0;\n}\n\n.groupsHeadingGroupName {\n  margin: 0 0 16px;\n  color: #000;\n  font-size: 16px;\n  font-weight: 700;\n}\n\n.groupsHeadingGroupMeta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 28px;\n  color: #4d4d4d;\n  font-size: 14px;\n}\n\n.groupsHeadingContextAction {\n  flex-shrink: 0;\n  min-height: 48px;\n  padding: 0 26px;\n  border: 2px solid;\n  background: transparent;\n  cursor: pointer;\n  font: inherit;\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.groupsHeadingContextAction-default {\n  border-color: #007bc0;\n  color: #007bc0;\n}\n\n.groupsHeadingContextAction-default:hover:not(:disabled) {\n  background: #d1e4ff;\n}\n\n.groupsHeadingContextAction-danger {\n  border-color: #e20015;\n  color: #e20015;\n}\n\n.groupsHeadingContextAction-danger:hover:not(:disabled) {\n  background: #ffe5e8;\n}\n\n.groupsHeadingContextAction:disabled,\n.groupsHeadingTab:disabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n\n.groupsHeadingTabs {\n  display: flex;\n  gap: 24px;\n  margin-top: 24px;\n  margin-bottom: -25px;\n  padding: 0;\n  overflow-x: auto;\n}\n\n.groupsHeadingTab {\n  border: 0;\n  border-bottom: 2px solid transparent;\n  padding: 10px 0;\n  background: transparent;\n  color: #000;\n  cursor: pointer;\n  font-family: \"Bosch Sans\", sans-serif;\n  font-size: 14px;\n  font-weight: 400;\n  white-space: nowrap;\n}\n\n.groupsHeadingTab:hover:not(:disabled),\n.groupsHeadingTabActive {\n  border-bottom-color: #007bc0;\n  color: #007bc0;\n}\n\n@media (max-width: 700px) {\n  .groupsHeading {\n    padding: 15px 20px 25px;\n  }\n\n  .groupsHeadingContent,\n  .groupsHeadingGroupDetails {\n    align-items: stretch;\n    flex-direction: column;\n  }\n\n  .groupsHeadingGroupSelector .MuiFormControl-root {\n    width: 100%;\n  }\n\n  .groupsHeadingGroupDetails {\n    padding: 22px;\n  }\n\n  .groupsHeadingContextAction {\n    width: 100%;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
